module.exports = __webpack_public_path__ + "static/media/6_30.a1e50074.png";